import React, {useState, useEffect, useContext} from 'react'
import {IconButton, Tab, Tabs} from '@material-ui/core'
import _ from 'lodash'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ItemRow from '../Views/PopGroupView/ItemRow'
import TabPanel from '../Views/PopGroupView/TabPanel'
import LoadingIndicator from '../../ReservationConfiguration/LoadingIcon'
import useCalendarViewContext from '../../../context/CalendarView'
import useSearchEntityFieldTypesReducer from '../../../state/entities/search-entity-field-types/reducer'
import {searchEntityFieldTypes} from '../../../state/entities/search-entity-field-types/actions'
import usePostCalendarViewReducer from '../../../state/calendar-views/post-calendar-view/reducer'
import {ReservationCalendarMainContext} from '../../../context/ReservationCalendarMain'

const DateStamps = () => {
  const [group, groupDispatch] = useSearchEntityFieldTypesReducer()
  const {viewData, setViewData} = useCalendarViewContext()
  const {calendarView} = useContext(ReservationCalendarMainContext)
  const {group_view: groupView = {entity_id: -1}} = viewData.selectedView || {}
  const [tab, setTab] = useState(0)
  const [expand, setExpand] = useState(true)

  const handleToggleGroup = (e, k, v) => {
    const _groups = _.cloneDeep(groupView.groups)
    if (!!_groups[k]) _groups[k].active = v
    const _group_view = {...groupView, groups: _groups}
    //
    setViewData(data => {
      data.selectedView = {group_view: _group_view}
      return {...data}
    })
  }

  const handleToggleActions = (xwe, k, v) => {
    const _actions = _.cloneDeep(groupView.actions)
    if (!!_actions[k]) _actions[k].active = v
    const _group_view = {...groupView, actions: _actions}
    setViewData(data => {
      data.selectedView = {group_view: _group_view}
      return {...data}
    })
  }

  const getViewColor = () => {
    if (!_.isEmpty(viewData.selectedFilteredViews)) {
      if (viewData.selectedFilteredViews.length > 1) {
        return groupView?.color
      } else {
        return viewData.selectedFilteredViews[0].color
      }
    } else {
      return groupView?.color
    }
  }

  // trigger load group data
  useEffect(() => {
    if (groupView.entity_id && groupView.entity_id !== -1) {
      searchEntityFieldTypes(groupDispatch, groupView.entity_id, {
        include_actions: false,
        include_related: true,
        field_types: ['DateField', 'DateFormulaField', 'CreatedAtField', 'DateTimeField'],
        currency_items: false,
        with_actions: true,
      })
    }
  }, [groupView.entity_id, groupDispatch])

  const color = getViewColor()

  return (
    <div style={{marginTop: 16}} hidden={calendarView === 'reservation'}>
      <div className="ap-flex ap-flex--align-center" style={{padding: '0 16px 0 16px'}}>
        <div className="ap-flex">
          <span style={{color: '#596175'}} className="ap-typography ap-typography--lg">
            Date Stamps
          </span>
        </div>
        <div container item xs={5} justify="ap-flex ap-flex--end">
          <IconButton
            size="small"
            className="ap-icon-button ap-icon-button--square"
            style={{color: '#596175'}}
            onClick={() => setExpand(p => !p)}
          >
            {expand ? <ExpandMoreIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </div>
      </div>
      <div style={{padding: '0 24px', marginTop: 8}} hidden={!expand}>
        <div style={{marginBottom: 8, display: 'flex', width: '100%'}}>
          <div
            style={{
              flex: 1,
              height: 26,
              color: tab === 0 ? '#1D2331' : '#596175',
              borderBottom: tab === 0 ? `solid 2px ${color || '#000'}` : '',
              textAlign: 'center',
              cursor: 'pointer',
            }}
            className="ap-typography"
            onClick={e => setTab(0)}
          >
            Group
          </div>
          <div
            style={{
              flex: 1,
              height: 26,
              color: tab === 1 ? '#1D2331' : '#596175',
              borderBottom: tab === 1 ? `solid 2px ${color || '#000'}` : '',
              textAlign: 'center',
              cursor: 'pointer',
            }}
            className="ap-typography"
            onClick={e => setTab(1)}
          >
            Action
          </div>
        </div>
        <TabPanel value={tab} index={0} className="ap-tab-panel">
          <div className="ap-scrollbar">
            {group.isLoading && <LoadingIndicator />}
            {(groupView?.groups || []).length === 0 && !group.isLoading && (
              <span className={`ap-typography ap-typography--xs ap-typography--gray`}>
                You currently have no date fields in your group. Add a date field in group
                configuration and it will populate here.
              </span>
            )}
            {!group.isLoading &&
              _.map(groupView?.groups || [], (g, gi) => (
                <ItemRow
                  color={color}
                  style={{borderBottom: 'unset', height: 24, marginBottom: 4, padding: 0}}
                  key={g.field_id}
                  data={(group.data.fields || []).find(f => f.id === g.field_id) || {}}
                  checked={g.active}
                  onChange={(e, v) => handleToggleGroup(e, gi, v)}
                />
              ))}
          </div>
        </TabPanel>
        <TabPanel value={tab} index={1} className="ap-tab-panel">
          <div className="ap-scrollbar">
            {group.isLoading && <LoadingIndicator />}
            {(groupView?.actions || []).length === 0 && !group.isLoading && (
              <span className={`ap-typography ap-typography--xs ap-typography--gray`}>
                You currently have no actions in this group. Create an action in group configuration
                and it will populate here.
              </span>
            )}
            {!group.isLoading &&
              _.map(groupView?.actions || [], (g, gi) => (
                <ItemRow
                  color={color}
                  style={{borderBottom: 'unset', height: 24, marginBottom: 4, padding: 0}}
                  key={g.action_id}
                  data={(group.data.actions || []).find(a => a.id === g.action_id) || {}}
                  checked={g.active}
                  onChange={(e, v) => handleToggleActions(e, gi, v)}
                />
              ))}
          </div>
        </TabPanel>
      </div>
    </div>
  )
}

export default DateStamps
